module.exports = __webpack_public_path__ + "static/media/logo_Kystverket-english.d37a4714.svg";